import * as React from 'react';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import { grey, yellow } from '@mui/material/colors';
import Button from '@mui/material/Button';
import { title } from 'process';


export let darkPalette = {
  mode: 'dark',
  primary: {
    main: "#ffd700", // or #81D4FA
    contrastText: "#000",
  },
  secondary: {
    main: '#fff',
  },
  cancel: {
    main: '#9aa3ad',
  },
  text: {
    primary: "#FFF",
    title: "#FFF",
    highlight: "#1890ff",
  },
  background: {
    default: "#000",
    paper: "#1d1d1d",
    highlight: "#080808",
    clear: "#1f1f1f",
  },
}

export let lightPalette = {
  mode: 'light',
  primary: {
    main: "#ffc200",
    contrastText: "#000",
  },
  secondary: {
    main: '#000',
    contrastText: "#FFF",
  },
  cancel: {
    main: '#9aa3ad',
  },
  text: {
    primary: "#000",
    highlight: "#1890ff",
  },
  background: {
    default: "#F4F6F8",
    highlight: "#e6f7ff",
    clear: "#f3f8fe"
  },

}


export let baseTheme = {
  typography: {
    fontSize: 13,
    fontFamily: [
      'Public Sans',
      // 'Roboto',
      'sans-serif',
    ].join(','),
  },
  components: {

    // Name of the component
    MuiListItem: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          cursor: 'pointer',

        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // Some CSS
          borderRadius: 10,
          // padding: "10px 20px",
        },
        contained: {
          boxShadow: "none",
        }
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          // Some CSS
          borderRadius: 10,
          // padding: "10px 20px",
        },
      },
    },
    RichTextField: {
      styleOverrides: {
        root: {
          // Some CSS
          borderRadius: 10,
          // padding: "10px 20px",
        },
        menubar: {

        }
      },
    },
    // MenuBar: {
    //   styleOverrides: {
    //     root: {
    //       // Some CSS
    //       // backgroundColor: "#F4F6F8!important",
    //       // background: "#F4F6F8!important",
    //       borderRadius: 10,

    //     },
    //   },
    // },


    // MuiDrawer: {
    //   styleOverrides: {
    //     paper: {
    //       backgroundColor: "#000",
    //       color:"#FFF"
    //     },
    //     root: {
    //       color:"white"
    //     }

    //   }
    // }

  },
};

export let darkTheme = createTheme({
  ...baseTheme,
  components: {
    ...baseTheme.components,
    MenuBar: {
      styleOverrides: {
        root: {
          // Some CSS
          backgroundColor: "#1d1d1d!important",
          background: "#1d1d1d!important",
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,

        },
      },
    },
  },
  palette: darkPalette
});

export let lightTheme = createTheme({
  ...baseTheme,
  components: {
    ...baseTheme.components,
    MenuBar: {
      styleOverrides: {
        root: {
          // Some CSS
          backgroundColor: "#F4F6F8!important",
          background: "#F4F6F8!important",
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
        },
      },
    },
  },
  palette: lightPalette
});


